import { ENUM__redux_action } from '@/state/_base/ENUM__redux_action';
import { PayloadAction } from '@reduxjs/toolkit';
import { DTO__grid2d } from '@shared/dto/grid2d/DTO__grid2d';
import { DTO__grid2d_cell } from '@shared/dto/grid2d_cell/DTO__grid2d_cell';
import { FN_SLICE__grid2d_recreate } from '../_methods/FN_SLICE__grid2d_recreate';
import { STATE__grid2d } from '../STATE__grid2d';

export const LOCAL__grid2d_cells_delete = (items: DTO__grid2d_cell[]): PayloadAction<DTO__grid2d_cell[]> => ({
  type: ENUM__redux_action.GRID2D_CELLS_DELETE,
  payload: items,
});

export function INIT_LOCAL__grid2d_cells_delete(state: STATE__grid2d, action: PayloadAction<DTO__grid2d_cell[]>) {
  let items = action.payload;

  if (items.is_empty()) return;

  for (let item of items) {
    let grid2d = state.grids2d_map.get(item.grid2d_id);
    try_delete_cell(grid2d, item);
  }

  //refresh map to trigger re-render
  FN_SLICE__grid2d_recreate(state);
}

function try_delete_cell(grid2d: DTO__grid2d | undefined, item: DTO__grid2d_cell) {
  if (!grid2d) return; //could be null if user still doesnt load this grid

  grid2d.cell__delete(item);
}
